export const table = {
      code: 'Code',
      product: 'Product',
      category: 'Category',
      unit: 'Unit / Presentation',
      warehouse: 'Warehouse',
      minimum: 'Minimum',
      maximum: 'Maximum',
      cost: 'Cost',
      value: 'Value',
      availableBoxes: 'Available boxes',
      type: 'Type',
      quantity: 'Quantity',
      stock: 'Stock',
      date: 'Date',
      report: 'Report',
      description: 'Description',
    } as const;
